import { GenericFilter } from '@/components/GenericFilter';
import type { FilterTypeWithValue } from '@shelflix/schemas/_common/filter.types';
import { EMaterialStatus } from '@shelflix/schemas/material/enums';
import type { ListMaterialFilterType, ListMaterialFilterTypeWithValues } from '@shelflix/schemas/material/list';
import AppIcon from '@shelflix/ui-web/components/AppIcon';
import { Button } from '@shelflix/ui-web/components/ui/button';
import blocksSvg from '@/assets/icons-normalized/blocks.svg?raw';
import sheetSvg from '@/assets/icons-normalized/sheet.svg?raw';
import { cn } from '@/utils/utils';

export function MaterialListFilter({
  states = [],
  brands = [],
  materials = [],
  displayListAsGrid,
  setDisplayListAsGrid,
  onChange,
  initialValue,
  initialFilters,
}: {
  states: string[];
  brands: string[];
  materials: string[];
  displayListAsGrid: boolean;
  setDisplayListAsGrid: (value: boolean) => void;
  onChange: (filters: ListMaterialFilterTypeWithValues) => void;
  initialValue?: ListMaterialFilterTypeWithValues['search'];
  initialFilters?: FilterTypeWithValue<{ name: string; condition: string; value: unknown }>[];
}) {
  const options: ListMaterialFilterType = {
    search: {
      label: 'Nome, local ou identificador',
      fields: ['name', 'campanha', 'code', 'facilityName', 'displayExternalId'],
    },
    filter: [
      {
        order: 0,
        label: 'Catálogo de Materiais',
        field: {
          condition: 'equals',
          name: 'material',
        },
        items: [
          ...materials.map((material) => ({
            text: material,
            value: material,
          })),
        ],
      },
      {
        order: 0,
        label: 'Marcas',
        field: {
          condition: 'equals',
          name: 'brand',
        },
        items: [
          ...brands.map((brand) => ({
            text: brand,
            value: brand,
          })),
        ],
      },
      {
        order: 0,
        label: 'Status',
        field: { name: 'status', condition: 'in' },
        items: [
          { text: 'Online', value: [EMaterialStatus.ACTIVE, EMaterialStatus.OPERATIONALONLINE] },
          { text: 'Offline', value: [EMaterialStatus.OFFLINE] },
          { text: 'Manutenção', value: [EMaterialStatus.MAINTENANCE, EMaterialStatus.STANDBY] },
        ],
      },
      {
        order: 0,
        label: 'Estado',
        field: { name: 'state', condition: 'equals' },
        items: states.map((state) => ({
          text: state,
          value: state,
        })),
      },
    ],
  };

  const customComponent = [
    <div>
      <span className="font-regular text-xs text-[#B2A598]">Visualização</span>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="lg"
          className={cn('size-10 p-1.5', {
            'border-[#E57300] dark:border-[#E57300]': displayListAsGrid,
          })}
          onClick={() => {
            setDisplayListAsGrid(true);
          }}
        >
          <AppIcon
            source="svg"
            name="blocks"
            svgContent={blocksSvg}
            size={28}
            weight={400}
            colorStyle={{ type: 'solid', color: displayListAsGrid ? '#E57300' : '#332F2B' }}
            className="[&_svg]:size-7!"
          />
        </Button>
        <Button
          variant="outline"
          size="lg"
          className={cn('size-10 p-1.5', {
            'border-[#E57300] dark:border-[#E57300]': !displayListAsGrid,
          })}
          onClick={() => {
            setDisplayListAsGrid(false);
          }}
        >
          <AppIcon
            source="svg"
            name="sheet"
            svgContent={sheetSvg}
            size={28}
            weight={400}
            colorStyle={{ type: 'solid', color: !displayListAsGrid ? '#E57300' : '#332F2B' }}
            className="[&_svg]:size-7!"
          />
        </Button>
      </div>
    </div>,
  ];

  return (
    <GenericFilter
      options={options}
      onChange={onChange}
      initialValue={initialValue}
      initialFilters={initialFilters}
      customComponents={customComponent}
    />
  );
}
